<template>
  <div class="member-center">
    <div class="header">
      <div class="slider-banner banner">
        <swiper class="swiper-wrapper" :options="swiperVip" ref="mySwiper">
          <swiperSlide
            class="swiper-slide memberBg"
            :class="item.class"
            v-for="(item, index) in vipList"
            :key="index"
            :style="{ backgroundImage: 'url(' + item.image + ')' }"
          >
            <!--            <img :src="item.icon" />-->
            <div class="name">{{ item.name }}</div>
            <div class="discount">购买会员商品成为至尊会员</div>
            <div class="lock" v-if="item.grade > grade">
              <span class="iconfont icon-quanxianguanlisuozi"></span
              >该会员等级尚未解锁
            </div>
            <div class="lock" v-if="item.grade < grade">
              <span class="iconfont icon-xuanzhong1"></span>已解锁更高等级
            </div>

            <!--<div class="buy_box" v-if="item.is_clear">-->
            <!--<div class="price" v-if="item.id == 12">168元</div>-->
            <!--<div class="price" v-if="item.id == 13">365元</div>-->
            <!--<div class="buy_btn" @click="recharge(item.id)">立 即 购 买</div>-->
            <!--</div>-->

            <div class="hykh" v-if="userInfo.phone">会员卡号：{{ cardPrefix }}8000{{ uid }}</div>
          </swiperSlide>
        </swiper>
      </div>
    </div>

    <div class="user ">
      <div class="wrapper" style="padding-bottom: 0">
        <div class="nav acea-row row-middle">
          <router-link :to="{ path: '/user/account' }" class="item">
            <div class="pic">
              <img src="../../assets/images/myyue.png" alt="" />
            </div>
            <div>我的余额</div>
            <div class="num">{{ userInfo.now_money || 0 }}</div>
          </router-link>
          <router-link
            :to="'/user/user_promotion'"
            class="item"
            v-if="userInfo.is_promoter === 1 || userInfo.statu === 2"
          >
            <div class="pic">
              <img src="../../assets/images/myyj.png" alt="" />
            </div>
            <div>当前佣金</div>
            <div class="num">{{ userInfo.brokerage_price || 0 }}</div>
          </router-link>
          <router-link :to="'/user/integral'" class="item">
            <div class="pic">
              <img src="../../assets/images/myjf.png" alt="" />
            </div>
            <div>当前积分</div>
            <div class="num">{{ userInfo.integral || 0 }}</div>
          </router-link>
          <router-link :to="'/user/user_coupon'" class="item">
            <div class="pic">
              <img src="../../assets/images/myyhj.png" alt="" />
            </div>
            <div>优惠券</div>
            <div class="num">{{ userInfo.couponCount || 0 }}</div>
          </router-link>
        </div>
      </div>
    </div>

    <div class="wrapper">
      <div class="title acea-row row-between-wrapper" style="display:flex;">
        <div><span class="iconfont icon-jingyanzhi"></span>会员二维码</div>
        <div style="padding-right: 0.27rem;">
          <span>UID:{{ uid }}</span>
        </div>
      </div>

      <div style="width: 50%;margin: 0 auto;">
        <div
          style="width: 130px;height: 130px;background: #f1f1f1;margin: 0 auto;"
          id="qrcode"
        >
          <img
            :src="userInfo.cancel_code"
            style="width: 130px;height: 130px;"
          />
        </div>
      </div>
    </div>
    <div class="wrapper" style="display: none">
      <div class="title acea-row row-between-wrapper">
        <div><span class="iconfont icon-jingyanzhi"></span>会员升级要求</div>
        <div class="num">
          <span class="current">{{ taskCount }}</span
          >/{{ vipRequire.length }}
        </div>
      </div>
      <div class="list">
        <div class="item" v-for="(item, index) in vipComplete" :key="index">
          <div class="top acea-row row-between-wrapper">
            <div class="name">
              {{ item.name
              }}<span
                class="iconfont icon-wenti"
                v-if="item.illustrate"
                @click="showGrow(item)"
              ></span>
            </div>
            <div>{{ item.finish ? "已满足条件" : "未满足条件" }}</div>
          </div>
          <div class="cu-progress">
            <div class="bg-red" :style="{ width: item.speed + '%' }"></div>
          </div>
          <div class="experience acea-row row-between-wrapper">
            <div>{{ item.task_type_title }}</div>
            <div>
              <span class="num">{{ item.new_number }}</span
              >/{{ item.number }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="recommend">
      <div class="title acea-row row-center-wrapper">
        <span class="iconfont icon-zhuangshixian"></span>
        <span class="name" v-if="this.vipList.length > 0">{{
          this.vipList[this.activeIndex].name || ""
        }}</span>
        <span class="iconfont icon-zhuangshixian lefticon"></span>
      </div>
      <div class="recommendList acea-row row-between-wrapper">
        <router-link
          :to="{ path: '/detail/' + item.id }"
          class="item"
          v-for="(item, index) in hostProduct"
          :key="index"
        >
          <div class="pictrue">
            <img :src="item.image" class="image" />
          </div>
          <div class="name line1">{{ item.store_name }}</div>
          <div class="money font-color-red">
            ￥<span class="num">{{ item.price }}</span>
          </div>
        </router-link>
      </div>
    </div>

    <div
      class="contain-hy wrapper"
      v-if="vipList[activeIndex] && vipList[activeIndex].grade == grade"
    >
      <div class="text2">
        <div class="item">
          <div class="tip" v-html="vipList[activeIndex].description"></div>
        </div>
      </div>
    </div>

    <div class="growthValue" :class="growthValue === false ? 'on' : ''">
      <div class="pictrue">
        <img src="@assets/images/value.jpg" /><span
          class="iconfont icon-guanbi3"
          @click="growthTap"
        ></span>
      </div>
      <div class="conter">
        {{ illustrate }}
      </div>
    </div>
    <div class="mask" :hidden="growthValue" @click="growthTap"></div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
import { getVipInfo, getVipTask, fuWechat, getUser } from "../../api/user";
import { getIntegralVipProducts } from "@api/store";
export default {
  name: "Poster",
  components: {
    swiper,
    swiperSlide
  },
  props: {},
  data: function() {
    return {
      userInfo: {},
      uid: "",
      surplus: "",
      vipList: [], //等级列表
      vipRequire: [], //等级要求
      vipComplete: [], //完成情况
      taskCount: 0, //任务数
      grade: 0, //当前会员等级
      swiperVip: {
        speed: 1000,
        effect: "coverflow",
        slidesPerView: "auto",
        centeredSlides: true,
        // loop: true,
        coverflowEffect: {
          rotate: 0, // 旋转的角度
          stretch: -20, // 拉伸   图片间左右的间距和密集度
          depth: 100, // 深度   切换图片间上下的间距和密集度
          modifier: 2, // 修正值 该值越大前面的效果越明显
          slideShadows: false // 页面阴影效果
        },
        observer: true,
        observeParents: true
      },
      loading: false,
      growthValue: true,
      illustrate: "",
      activeIndex: 0,
      cardPrefix: "",

      hostProduct: []
    };
  },
  watch: {
    vipList: function() {
      console.log(this.vipList);
      let that = this;
      if (that.vipList.length > 0) {
        let sub_index = null;
        let sub_grade = null;
        that.vipList.forEach(function(item, index) {
          if (item.is_clear === false) {
            console.log("1234");
            sub_index = index;
            sub_grade = item.grade;
          }
        });
        if (sub_index != null) {
          that.swiper.slideTo(sub_index);
          that.activeIndex = sub_index;
          that.grade = sub_grade;
        }
      }
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  mounted: function() {
    let that = this;
    that.User();
    that.getInfo();
    that.swiper.on("slideChange", function() {
      that.activeIndex = that.swiper.activeIndex;
      console.log(" | " + that.swiper.activeIndex);
      that.getTask();
    });
  },
  methods: {
    recharge: function(level_id) {
      let that = this;
      let uid = that.userInfo.uid;
      fuWechat({ level_id: level_id, uid: uid })
        .then(res => {
          var data = res.data;
          pay(data.data)
            .finally(() => {
              that.$dialog.toast({ mes: "支付成功" });
              that.User();
              that.getInfo();
            })
            .catch(function() {
              that.$dialog.toast({ mes: "支付失败" });
            });
        })
        .catch(res => {
          that.$dialog.toast({ mes: res.msg });
        });
    },
    User: function() {
      let that = this;
      getUser().then(res => {
        that.userInfo = res.data;
        that.surplus = res.data.surplus;
        that.uid = res.data.uid;
      });
    },
    growthTap: function() {
      this.growthValue = true;
    },
    getInfo: function() {
      let that = this;
      getVipInfo().then(res => {
          (that.cardPrefix = res.data.card_prefix),
            (that.vipList = res.data.list);
          that.vipRequire = res.data.task.list;
          that.vipComplete = res.data.task.task;
          that.taskCount = res.data.task.reach_count;
        },
        err => {
          that.$dialog.message(err.msg);
        }
      );
    },
    getTask: function() {
      let that = this;
      getVipTask(that.vipList[that.activeIndex].id).then(
        res => {
          that.vipRequire = res.data.list;
          that.vipComplete = res.data.task;
          that.taskCount = res.data.reach_count;
        },
        err => {
          that.$dialog.message(err.msg);
        }
      );

      getIntegralVipProducts({
        page: 1,
        limit: 8,
        level_id: that.vipList[that.activeIndex].id, //二级分类id
        news: 0
      }).then(res => {
        this.hostProduct = res.data;
        console.log(res.data);
      });
    },
    showGrow: function(item) {
      if (this.illustrate != item.illustrate) this.illustrate = item.illustrate;
      this.growthValue = false;
    }
  }
};
</script>
<style scoped>
.buy_box {
  width: 2rem;
  position: absolute;
  top: 1.7rem;
  right: 0.3rem;
  text-align: center;
}
.buy_box .price {
  font-size: 0.4rem;
  font-weight: bold;
  margin-bottom: 0.15rem;
}
.buy_box .buy_btn {
  font-size: 0.22rem;
  background-image: linear-gradient(to right, #fa6514 0%, #e93323 100%);
  color: #ffffff;
  box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.3);
  border-radius: 0.56rem;
  line-height: 1.2;
  padding: 0.1rem 0.3rem;
  display: inline-block;
}
.hykh {
  position: absolute;
  right: 10px;
  bottom: 5px;
  font-size: 12px;
}
.contain-hy {
  margin: 0 auto;
  padding-top: 0;
}
.contain-hy .text2 {
  width: 6.9rem;
  padding: 0.1rem 0rem;
  margin: 0.2rem auto;
  border-radius: 0.12rem;
}
.contain-hy .text2 .name {
  font-weight: bold;
  color: #b60004;
  margin-bottom: 0.1rem;
}
.contain-hy .text2 .tip {
}

.member-center .header {
  background: transparent;
  position: relative;
}
.member-center .header:after {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 1.2rem;
  z-index: -1;
  content: "";
  height: 4rem;
  width: 100%;
  border-radius: 0 0 50% 50%;
  background-color: #232323;
}
.user .wrapper .nav {
  height: 2rem;
}
.user .wrapper .nav .item .pic {
}
.user .wrapper .nav .item .pic img {
  height: 0.5rem;
}
</style>
